export const COLOR_PALETTE = {
  VM: '#96e6ab',
  EJ: '#76ace0',
  WBG: '#df87a8',
  W2J: '#f4d353',
};

export const FALLBACK_COLORS = [
  '#b3e2cd',
  '#fdcdac',
  '#cbd5e8',
  '#f4cae4',
  '#e6f5c9',
  '#fff2ae',
  '#f1e2cc',
  '#cccccc',
  '#8dd3c7',
  '#ffffb3',
];

export const buildColorGetter = (preferredOrder = []) => {
  const paletteEntries = preferredOrder
    .map((name) => [name, COLOR_PALETTE[name]])
    .filter(([, value]) => Boolean(value));

  const palette = new Map(paletteEntries);

  return (item, index) => {
    if (item?.color) {
      return item.color;
    }

    const key = item?.label ?? item?.name;
    if (key && palette.has(key)) {
      return palette.get(key);
    }

    const colors = [...Object.values(COLOR_PALETTE), ...FALLBACK_COLORS];
    return colors[index % colors.length];
  };
};
